import React, { useEffect } from "react";
import { Grid, Button } from "semantic-ui-react";
import { Field } from "redux-form";
import { renderTextField } from "../../formcomponents";
import { ImageUrl } from "../../formcomponents/Constants";
import ImageFileUploadFileId from "../../formcomponents/ImageFileUploadFileId";
import pdfIcon from "./pdfIcon.jpeg";
const MParArrList = ({
  fields,

  meta: { touched, error, submitFailed },
}) => {
  useEffect(() => {
    fields.push();
  }, []);

  return (
    <ul>
      <Grid columns={3}>
        {fields.map((item, index) => (
          <Grid.Row>
            <Grid.Column>
              <Field
                name={`${item}.partnerName`}
                type="text"
                component={renderTextField}
                label="Name"
              />
              <Field
                name={`${item}.partnerPercentage`}
                type="text"
                component={renderTextField}
                label="Percentage"
              />
            </Grid.Column>

            <Grid.Column>
              {" "}
              <Field
                name={`${item}.partnerPosition`}
                type="text"
                component={renderTextField}
                label="Position"
              />{" "}
              <Field
                name={`${item}.partnerFileId`}
                type="file"
                component={ImageFileUploadFileId}
                label="File"
              />
            </Grid.Column>
            <Grid.Column>
              <br />
              <li key={index} style={{ listStyleType: "none" }}>
                <Button
                  type="button"
                  floated="right"
                  negative
                  onClick={() => fields.remove(index)}
                >
                  X
                </Button>
                {fields.length - 1 === index && (
                  <Button
                    type="button"
                    positive
                    floated="right"
                    onClick={() => fields.push({})}
                  >
                    Add
                  </Button>
                )}
              </li>
            </Grid.Column>
          </Grid.Row>
        ))}
        <br />
        {(touched || submitFailed) && error && <span>{error}</span>}
      </Grid>
    </ul>
  );
};

export default MParArrList;
